import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    outcomeTypeId: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    odds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    order: PropTypes.number,
    // marketId: PropTypes.number.isRequired,
    // isMain: PropTypes.bool.isRequired,
    orderPosition: PropTypes.number,
    outcomeStatus: PropTypes.oneOf(['UNSPECIFIED', 'WIN', 'LOSE', 'VOID']),
    marketStatus: PropTypes.oneOf([
      'ACTIVE',
      'SUSPENDED',
      'DEACTIVATED',
      'SETTLED',
      'CANCELLED',
      'HANDED_OVER',
    ]),
    marketVisible: PropTypes.bool,
    marketSuspended: PropTypes.bool,
  }),
  PropTypes.shape({
    isFake: PropTypes.bool.isRequired,
    key: PropTypes.bool.isRequired,
  }),
]);
